import { render, staticRenderFns } from "./CreateKnowhowForm.vue?vue&type=template&id=9f74fc0e&"
import script from "./CreateKnowhowForm.vue?vue&type=script&lang=js&"
export * from "./CreateKnowhowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports